import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Rx';

import { Ubicacion } from './ubicacion';

import myGlobals = require('../config');

@Injectable()
export class UbicacionService {

  private ubicacionUrl = myGlobals.default.BASE_URL + '/ubicacion/';  // URL to web api

  constructor(private http: Http) { }

  //Obtener todas las ubicacions
  getUbicaciones() {
    return this.http.get(this.ubicacionUrl)
      .map((response) => response.json());
  }

  //Obtener una ubicacion
  getUbicacion(_id: string): Observable<Ubicacion> {
    return this.http.get(this.ubicacionUrl + _id)
      .map((response) => response.json());
  }

  save(ubicacion: Ubicacion): Observable<Ubicacion> {
    if (ubicacion._id) {
      return this.put(ubicacion);
    }
    //Seteo estado activo
    ubicacion.estado = true;
    return this.post(ubicacion);
  }

  //Desactivar ubicacion
  delete(ubicacion: Ubicacion): Observable<Ubicacion> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.ubicacionUrl}/${ubicacion._id}`;

    return this.http
      .delete(url, { headers: headers })
      .map((response) => response.json());
  }

  // Agregar nueva ubicacion
  private post(ubicacion: Ubicacion): Observable<Ubicacion> {
    let headers = new Headers({
      'Content-Type': 'application/json;charset=UTF-8'
    });
    headers.append('dataType', 'json');
    console.log(JSON.stringify(ubicacion));
    var ubicacionStr = JSON.stringify(ubicacion);
    return this.http
      .post(this.ubicacionUrl, ubicacionStr, { headers: headers })
      .map((response) => response.json());
  }

  // Actualizar ubicacion
  private put(ubicacion: Ubicacion) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.ubicacionUrl}/${ubicacion._id}`;

    return this.http
      .put(url, JSON.stringify(ubicacion), { headers: headers })
      .map((response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/ubicacion/ubicacion.service.ts